import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getCategories = async () => {
  const res = await axiosInstance.get('productcategory/get-product-categories');
  return res.data;
};

export const getCategoryById = async (id) => {
  const res = await axiosInstance.get(`productcategory/get-product-category/${id}`);
  return res.data;
};

export const addCategory = async (category) => {
  const res = await axiosInstance.post('productcategory/add-product-category', category);
  return res.data;
};

export const updateCategory = async (id, category) => {
  const res = await axiosInstance.put(`productcategory/update-product-category/${id}`, category);
  return res.data;
};

export const deleteCategory = async (id) => {
  await axiosInstance.delete(`productcategory/delete-product-category/${id}`);
};